import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, ApplicationRef } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from 'src/app/shareModule/states/app.state';
import { selectUser } from 'src/app/shareModule/states/user-details/user-details.selector';
import { loadUser } from 'src/app/shareModule/states/user-details/user-details.action';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { MemberNotificationService } from 'src/app/shareModule/services/member-notification.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-advanced-settings-seo',
  templateUrl: './advanced-settings-seo.component.html',
  styleUrls: [
    './advanced-settings-seo.component.scss',
    '../advanced-settings.component.scss'
  ],
})
export class AdvancedSettingsSeoComponent implements OnInit {

  public userInfo: any;

  constructor(
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
    private appRef: ApplicationRef,
    private auth: AuthServiceService,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
    this.store.pipe(select(selectUser)).subscribe((response: any) => {
      try {
        if (response) {
          const data = response;

          this.userInfo = {
            isVerified: data.isVerified,
            phone: data.phone,
            isEmailVerify: data.isEmailVerify,
            noIndexProduct: data.noIndexProduct,
          };

          this.cdr.detectChanges();
          this.appRef.tick();
        }
      } catch (error) {
        console.log("error", error, "PROFILE")
      }
    });
  }

  ngAfterViewInit(): void {
    this.store.dispatch(loadUser({}));
  }

  public saveProfileInfo(): void {
    let payload = this.userInfo;

    const formData = new FormData

    Object.keys(payload)
      .map((row) => {
        if (typeof payload[row] === 'boolean') {
          formData.append(row, payload[row] ? '1' : '0');
        } else {
          formData.append(row, payload[row]);
        }
      })

    this.auth.updateProfileCharacterDetails(formData).subscribe(
      (resp: ApiResponse) => {
        if (resp.message) {
          this.toastr.success(resp.message);
          this.store.dispatch(loadUser({}));
        }
      },
      ({ error }) => {
        this.toastr.error(error.message);
      }
    );
  }
}
